export default __webpack_public_path__ + "static/top-banner-94ef6854e522442cedc1255077ef7d78.png";